import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import { EnvConfigService } from '../env-config/env-config.service';

export const IDEMPOTENCY_KEY_HEADER = 'Idempotency-Key';

// Identity and Study Manager run the platform `pharmatrail.idempotency` middleware and expect the
// header on every request but a preflight, the same way pt-core sends it from the admin and
// investigator apps. The Designer API behind `api.baseUrl` does not take part in it.
const SKIPPED_METHODS = ['OPTIONS'];

export const idempotencyInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  if (SKIPPED_METHODS.includes(req.method.toUpperCase()) || req.headers.has(IDEMPOTENCY_KEY_HEADER)) {
    return next(req);
  }

  const api = inject(EnvConfigService).config().api;
  const platformHosts = [api.identity, api.studyManager].filter(host => !!host);

  if (!platformHosts.some(host => req.url.startsWith(host))) {
    return next(req);
  }

  return next(req.clone({ setHeaders: { [IDEMPOTENCY_KEY_HEADER]: uuidv4() } }));
};
